/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reward tier with unlock requirements
 * @export
 * @interface SurfaceRewardTier
 */
export interface SurfaceRewardTier {
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardTier
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardTier
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardTier
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardTier
     */
    imageUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceRewardTier
     */
    requiredLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof SurfaceRewardTier
     */
    requiredPoints?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardTier
     */
    bonusText?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceRewardTier
     */
    category?: SurfaceRewardTierCategoryEnum;
}


/**
 * @export
 */
export const SurfaceRewardTierCategoryEnum = {
    IN_GAME: 'IN_GAME',
    MERCH: 'MERCH',
    EXCLUSIVE: 'EXCLUSIVE',
    XP_BOOST: 'XP_BOOST'
} as const;
export type SurfaceRewardTierCategoryEnum = typeof SurfaceRewardTierCategoryEnum[keyof typeof SurfaceRewardTierCategoryEnum];


/**
 * Check if a given object implements the SurfaceRewardTier interface.
 */
export function instanceOfSurfaceRewardTier(value: object): value is SurfaceRewardTier {
    return true;
}

export function SurfaceRewardTierFromJSON(json: any): SurfaceRewardTier {
    return SurfaceRewardTierFromJSONTyped(json, false);
}

export function SurfaceRewardTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceRewardTier {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'requiredLevel': json['requiredLevel'] == null ? undefined : json['requiredLevel'],
        'requiredPoints': json['requiredPoints'] == null ? undefined : json['requiredPoints'],
        'bonusText': json['bonusText'] == null ? undefined : json['bonusText'],
        'category': json['category'] == null ? undefined : json['category'],
    };
}

export function SurfaceRewardTierToJSON(json: any): SurfaceRewardTier {
    return SurfaceRewardTierToJSONTyped(json, false);
}

export function SurfaceRewardTierToJSONTyped(value?: SurfaceRewardTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'imageUrl': value['imageUrl'],
        'requiredLevel': value['requiredLevel'],
        'requiredPoints': value['requiredPoints'],
        'bonusText': value['bonusText'],
        'category': value['category'],
    };
}

